const NotificationsList = ({
  notifications,
}: {
  notifications: { id: number; message: string }[];
}) => {
  return (
    <div className="text-start z-50 fixed bottom-[1.75rem] right-[1.75rem] flex flex-col gap-[10px]">
      {notifications.map((item) => (
        <div
          key={item.id}
          className="w-[25rem] flex flex-row gap-[10px] bg-white rounded-[8px] border border-[#d9d9d9] p-[18px] animate-notification"
        >
          <img
            className="w-[1rem]"
            alt="필터 아이콘"
            src="/assets/icons/btn_Check box On.svg"
          />
          <div>{item.message}</div>
        </div>
      ))}
    </div>
  );
};

export default NotificationsList;
